import { css } from 'lit'

export const baseStyles = css`
  :host {
    display: block;
    /*
     * Match the webfont family the host sites load (Monotype Avenir kit) and
     * the footer's :host font, so header text renders in the same typeface as
     * the rest of the page instead of falling back to system 'Avenir' (present
     * on macOS, absent on Windows) — which made the header look different per
     * OS/site. @font-face declared by the host document applies inside shadow DOM.
     */
    font-family:
      'Avenir LT W01_45 Book1475508',
      'Avenir',
      sans-serif;
    font-weight: 400;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`